var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-btn',{staticClass:"ml-2",attrs:{"min-width":"0","to":"/","exact":""}},[_vm._v(" Help "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-help")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }